import Swiper, {Pagination} from "swiper";
import viewportChecker from "../../sources/jquery.viewportchecker.min";

export function initReservLanding2(){
    if(!$('#reserv_landing_2').length) return;

    Swiper.use([Pagination]);

    //viewportChecker
        if ($('.contentEffect').length) {
            $('.contentEffect').viewportChecker({
                classToAdd: 'effectShow',
                offset: 100
            });
        }

        if ($('.effectOut').length) {
            $('.effectOut').viewportChecker({
                classToAdd: 'contentEffectOut',
                offset: 100
            });
        }

        if ($('.section-item__iphone').length) {
            $('.section-item__iphone').viewportChecker({
                classToAdd: 'section-item__iphone--anim visible',
                offset: 100
            });
        }

        if ($('.section-item__shield').length) {
            $('.section-item__shield').viewportChecker({
                classToAdd: 'section-item__shield--anim visible',
                offset: 100
            });
        }

        // For Swiper
        if ($('#main_slider').length) {

            $('#slider_tabs .section__button').click(function () {
                var goToThisIndex = $(this).attr("data-slide");
                mainSlider.slideTo(goToThisIndex, 800, false);
                $(this).addClass('section__button--active').siblings().removeClass('section__button--active');
            });


            var mainSlider = new Swiper('.swiper-container', {
                speed: 800,
                autoHeight: true,
                loop: false,
                on: {
                    slideChange: function () {
                        var slideId = $('.swiper-slide-active').attr("data-slide");
                        $('#slider_tabs .section__button').each(function (i) {
                            if ($(this).attr('data-slide') == mainSlider.realIndex) {
                                $(this).addClass('section__button--active').siblings().removeClass('section__button--active');
                            }
                        });


                    },

                },
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets'
                },

            });
        }
}